import React from 'react';
import { Loader2 } from 'lucide-react';

interface GeneratingCardProps {
  type: 'flashcard' | 'quiz' | 'summary';
}

const GENERATING_CONFIG: Record<string, { title: string; description: string }> = {
  flashcard: {
    title: 'Generating Flashcard',
    description: 'Creating flashcards based on your preferences'
  },
  quiz: {
    title: 'Generating Quiz',
    description: 'Creating questions based on your preferences'
  },
  summary: {
    title: 'Generating Summary',
    description: 'Creating summary based on your preferences'
  }
};

export const GeneratingCard: React.FC<GeneratingCardProps> = ({ type }) => {
  const config = GENERATING_CONFIG[type];

  return (
    <div className="mx-auto w-full max-w-3xl">
      <div className="w-full rounded-2xl border border-border bg-card p-4 shadow-sm cursor-not-allowed opacity-70">
        <div className="flex items-start justify-between gap-6">
          <div className="min-w-0 flex-1 space-y-2">
            <div className="flex min-w-0 items-center gap-2 text-base font-medium text-muted-foreground">
              <Loader2 className="h-4 w-4 flex-shrink-0 animate-spin" />
              <span className="truncate">{config.title}</span>
            </div>
            <div className="text-xs text-muted-foreground/70">
              {config.description}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
